'use es6';

import http from 'hub-http/clients/apiClient';
const BASE_URL = 'cos-rendering/v1/internal/render/widget';
const URL_WITH_META = `${BASE_URL}-with-meta`;
const BASE_URL_CONTENT_RENDERING = 'content-editor-rendering/v1/internal/render/module';
const URL_WITH_META_CONTENT_RENDERING = `${BASE_URL_CONTENT_RENDERING}-with-meta`;
export const render = data => {
  return http.post(BASE_URL, {
    data,
    responseType: 'text'
  });
};
export const renderModule = data => {
  return http.post(BASE_URL_CONTENT_RENDERING, {
    data,
    responseType: 'text'
  });
};
export const renderModuleWithMeta = (data, query) => {
  return http.post(URL_WITH_META_CONTENT_RENDERING, {
    data,
    query
  });
};
export const renderWithContext = (data, paramString = '', isUngatedForContentEditorRenderingEndpoint = false) => {
  return http.post(isUngatedForContentEditorRenderingEndpoint ? `content-editor-rendering/v1/internal/render/module-and-content${paramString}` : `cos-email-rendering/v1/internal/render/widget-and-content${paramString}`, {
    data,
    responseType: 'text'
  });
};
export const renderWithTemplateContext = data => {
  return http.post('cos-email-rendering/v1/internal/render/widget-and-template', {
    data,
    responseType: 'text'
  });
};
export const renderWithMeta = (data, query) => {
  return http.post(URL_WITH_META, {
    data,
    query
  });
};